import { useEffect } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../helpers/toAbsoluteUrl";
import { useBlogContext } from "context/BlogContext";
import "./BlogList.css";
import Loading from "components/Loading/Loading";

const BlogList = () => {
  const { blogs, fetchBlogs, blogsIsLoading, pageOptions, tooManyRequests } =
    useBlogContext();

  useEffect(() => {
    fetchBlogs();
  }, [pageOptions.page]);

  if (blogsIsLoading) {
    return <Loading />;
  }

  if (!blogsIsLoading && tooManyRequests) {
    return (
      <div className="blog-post-container">
        <div className="post-not-found">
          <img
            src="/assets/429.png"
            alt="404"
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
          />
          <p>You have made too many requests. Please try again later.</p>
        </div>
      </div>
    );
  }

  if (!blogsIsLoading && blogs.length === 0) {
    return (
      <div className="blog-post-container">
        <div className="post-not-found">
          <img
            src="/assets/404.png"
            alt="404"
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
          />
          <p>No blog posts found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-list">
      {blogs.map((post) => (
        <Link key={post.id} to={`/blog/${post.slug}`} className="blog-item">
          <div className="blog-thumbnail">
            <img
              src={toAbsoluteUrl(post.thumbnail)}
              alt={post.title}
              className="thumbnail-image"
            />
          </div>
          <div className="blog-item-content">
            <h3 className="blog-title" title={post.title}>
              {post.title}
            </h3>
            <p className="blog-excerpt">{post.excerpt}</p>
            <div className="blog-meta">
              <span className="blog-date">
                {new Date(post.publishDate).toLocaleDateString()}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default BlogList;
